export default "__VITE_ASSET__63ef42c0__"